export default __webpack_public_path__ + "static/media/user_poap_08.186e892a.svg";